
class Recaptcha {
	constructor() {
		this._init()
	}
	_init() {
	
    }
    
    onSubmit(token) {
        document.getElementById("Contact-reCAPTCHA-form").submit();
    }
}

export default Recaptcha